<template>
    <div :class=classes>
        <div class="mb-5 mb-md-3 section-header d-md-flex justify-content-between">
            <div class="d-flex">
                <div :style="`background-image: url(${valueC.vettoreIcon})`" :title="valueC.vettore"></div>
            </div>
            <div>
                <span class="mr-1">N° VOLO:</span><b>{{valueC.numero}}</b>
                <span class="mx-1">-</span>
                <span class="mr-1">CLASSE:</span><b>{{valueC.classe}}</b>
            </div>
            <div v-if="!isMobile" class="section-selezionato d-flex">
                <div v-if="!selected" class="position-relative" style="left: -10px; top: 2px">
                    <h4 :class="value.prezzoVenditaDelta>0? 'more currency' : 'minus currency'">{{value.prezzoVenditaDelta>=0? '+' + value.prezzoVenditaDelta:value.prezzoVenditaDelta}} &euro;</h4>
                </div>
                <h6 v-if="selected" class="position-relative text-primary default-bold text-uppercase" style="top: 8px; right: 10px">selezionato</h6>
                <button v-if="!selected" class="py-1 btn btn-primary mr-2" @click="onSelect">seleziona</button>
                <div class="icon-circle-border-blue">
                    <a href="javascript:void(0)" @click="onDetail">
                        <img src="../../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                    </a>
                </div>
            </div>
        </div>
        <div class="section-partenza-arrivo d-flex justify-content-between">
            <div>
                <b>{{valueC.partenza.citta}}</b>
                <span v-if="!isMobile">|</span>
                <span v-if="!isMobile">{{valueC.partenza.aereoporto}}</span>
            </div>
            <div>
                <b>{{valueC.arrivo.citta}}</b>
                <span v-if="!isMobile">|</span>
                <span v-if="!isMobile">{{valueC.arrivo.aereoporto}}</span>
            </div>
        </div>
        <div class="section-volo d-flex justify-content-between">
            <div class="flight-arrow arrow-right">
                <b>{{valueC.ore}}H {{valueC.minuti}}'</b>
                <div class="line"></div>
                <div>
                    <span v-if="numeroScali>0">
                        {{numeroScali}} {{numeroScali === 1 ? 'SCALO' : 'SCALI'}}
                    </span>
                    <AlertIcon v-if="isScaliSuDifferentiAereoporti" type="danger" placement="right" title="il trasferimento tra gli aereoporti non è compreso nel prezzo"/>
                </div>
            </div>
            <div>
                <div class="d-flex">
                    <h2 class="mr-1">{{valueC.partenza.sigla}}</h2>
                    <h3><b>{{valueC.partenza.orario}}</b></h3>
                </div>
                <span>{{valueC.partenza.data}}</span>
            </div>
            <div>
                <div class="d-flex justify-content-end">
                    <h3><b>{{valueC.arrivo.orario}}</b></h3>
                    <h2 class="ml-1">{{valueC.arrivo.sigla}}</h2>
                </div>
                <span>{{valueC.arrivo.data}}</span>
            </div>
        </div>
        <div v-if="isMobile" class="section-selezionato d-flex p-2 justify-content-between border-top mt-2">
            <h5 v-if="selected" class="position-relative text-primary default-bold text-uppercase mr-2" style="top: 5px">selezionato</h5>
            <div class="d-flex" v-if="!selected">
                <div>
                    <button class="py-1 btn btn-primary" @click="onSelect">seleziona</button>
                </div>
                <div class="position-relative" style="left: 10px; top: 2px">
                    <h4 :class="value.prezzoVenditaDelta>0? 'more currency' : 'minus currency'">{{value.prezzoVenditaDelta>=0? '+' + value.prezzoVenditaDelta:value.prezzoVenditaDelta}} &euro;</h4>
                </div>
            </div>
            <div class="icon-circle-border-blue">
                <a href="javascript:void(0)" @click="onDetail">
                    <img src="../../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                </a>
            </div>
        </div>
        <div v-for="(item, index) in this.value.voli" :key="index" :class="`section-dettaglio-volo d-md-flex justify-content-between py-4 ${(item.scali && item.scali.length) === 0? 'with-scalo' : ''}`">
            <div class="left mb-2">
                <div :style="`background-image: url(${valueC.vettoreIcon})`" :title="volo(item).vettore"></div>
                <div><span>N° VOLO:</span><b class="ml-1">{{volo(item).numero}}</b></div>
                <div><span>CLASSE:</span><b class="ml-1">{{volo(item).classe}}</b></div>
                <div><span>AEREO:</span><b class="ml-1">{{volo(item).aereo}}</b></div>
                <div><span>BAGAGLIO:</span><b class="ml-1">{{volo(item).bagaglio}}</b></div>
            </div>
            <div class="right">
                <div class="departure d-flex">
                    <div class="timeline start">
                        <h5>{{volo(item).partenza.orario}}</h5>
                    </div>
                    <div class="w-100 d-flex justify-content-between">
                        <div>
                            <b>{{volo(item).partenza.aereoporto}}</b>
                            <span>({{volo(item).partenza.sigla}})</span>
                            <span>-</span>
                            <b class="terminal mb-2" v-show="volo(item).partenza.terminal">Terminal: {{volo(item).partenza.terminal}}</b>
                        </div>
                        <div>
                            <span class="nowrap">{{volo(item).partenza.data}}</span>
                        </div>
                    </div>
                </div>
                <div v-for="(item2, index2) in volo(item).scali" :key="index2" :value="scalo" class="departure d-flex scalo">
                    <div class="timeline">
                        <h5>{{scalo(item2).orario}}</h5>
                    </div>
                    <div class="w-100 d-flex justify-content-between">
                        <div>
                            <b>{{scalo(item2).aereoporto}}</b>
                            <span>({{scalo(item2).sigla}})</span>
                            <span>-</span>
                            <b class="terminal mb-2" v-show="scalo(item2).terminal">Terminal: {{scalo(item2).terminal}}</b>
                        </div>
                    </div>
                </div>
                <div class="arrival d-flex">
                    <div class="timeline end">
                        <h5>{{volo(item).arrivo.orario}}</h5>
                    </div>
                    <div class="w-100 d-flex justify-content-between">
                        <div>
                            <b>{{volo(item).arrivo.aereoporto}}</b>
                            <span>({{volo(item).arrivo.sigla}})</span>
                            <span>-</span>
                            <b class="terminal mb-2" v-show="volo(item).arrivo.terminal">Terminal: {{volo(item).arrivo.terminal}}</b>
                        </div>
                        <div>
                            <span class="nowrap">{{volo(item).arrivo.data}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { simpleTimeFormatter, longDateFormatter } from '../../../../utils/formatter'
import {left} from 'strpad'
import AlertIcon from '../utils/AlertIcon'
import {airportName} from '../../../../utils/helper'
import scaliTecniciFake from '../../../../fake/scalo-tecnico.json'
import MobileDetector from '../../../common/MobileDetector'

export default {
  name: 'FlightSection',
  mixins: [MobileDetector],
  components: {AlertIcon},
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: ''
    },
    value: {
      type: Object
    }
  },
  computed: {
    classes: function () {
      return this.mode === 'detail' ? 'flight-section detail' : 'flight-section'
    },
    isScaliSuDifferentiAereoporti: function () {
      return this.value.voli.some(function (item, index, arr) {
        if (index === arr.length - 1) return false
        const iataDestinazioneCurrentVolo = item.destinazione.aeroporto.airport.objB
        const iataPartenzaNextVolo = arr[index + 1].partenza.aeroporto.airport.objB
        return iataDestinazioneCurrentVolo !== iataPartenzaNextVolo
      })
    },
    numeroScali: function () {
      return this.value.voli.length - 1
    },
    valueC: function () {
      const primoVolo = this.value.voli[0]
      const ultimoVolo = this.value.voli[this.value.voli.length - 1]

      const aeroportoPartenza = airportName(primoVolo.partenza.aeroporto.airport.objA)
      const aeroportoDestinazione = airportName(ultimoVolo.destinazione.aeroporto.airport.objA)

      const orarioPartenza = simpleTimeFormatter(primoVolo.partenza.dataOra.time.time[0], primoVolo.partenza.dataOra.time.time[1])
      const orarioDestinazione = simpleTimeFormatter(ultimoVolo.destinazione.dataOra.time.time[0], ultimoVolo.destinazione.dataOra.time.time[1])

      const datePartenzaObj = primoVolo.partenza.dataOra.date.date
      const dataPartenza = longDateFormatter(new Date(datePartenzaObj[0] + 2000, datePartenzaObj[1], datePartenzaObj[2]))

      const dateDestinazioneObj = ultimoVolo.destinazione.dataOra.date.date
      const dataDestinazione = longDateFormatter(new Date(dateDestinazioneObj[0] + 2000, dateDestinazioneObj[1], dateDestinazioneObj[2]))

      const vettoreSigla = this.value.vector.objB
      const vettoreIcon = require('../../../../assets/images/airlines/' + vettoreSigla + '.gif')

      return {
        vettore: this.value.vector.objA,
        vettoreSigla: vettoreSigla,
        vettoreIcon: vettoreIcon,
        numero: primoVolo.numeroVolo,
        classe: primoVolo.datiProposta.classe,
        aereo: primoVolo.aeromobile.objA,
        bagaglio: primoVolo.bagaglio.quantita + ' in stiva',
        ore: Math.trunc(this.value.durata / 60),
        minuti: left(this.value.durata % 60, 2, '0'),
        scali: primoVolo.numeroStop,
        partenza: {
          citta: primoVolo.partenza.aeroporto.city.objA,
          aereoporto: aeroportoPartenza,
          terminal: primoVolo.partenza.terminal,
          sigla: primoVolo.partenza.aeroporto.airport.objB,
          orario: orarioPartenza,
          data: dataPartenza
        },
        arrivo: {
          citta: ultimoVolo.destinazione.aeroporto.city.objA,
          aereoporto: aeroportoDestinazione,
          terminal: ultimoVolo.destinazione.terminal,
          sigla: ultimoVolo.destinazione.aeroporto.airport.objB,
          orario: orarioDestinazione,
          data: dataDestinazione
        }
      }
    }
  },
  methods: {
    onDetail: function () {
      this.$emit('detail')
    },
    onSelect: function () {
      this.$emit('select')
    },
    volo (volo) {
      const orarioPartenza = simpleTimeFormatter(volo.partenza.dataOra.time.time[0], volo.partenza.dataOra.time.time[1])
      const orarioDestinazione = simpleTimeFormatter(volo.destinazione.dataOra.time.time[0], volo.destinazione.dataOra.time.time[1])
      const datePartenzaObj = volo.partenza.dataOra.date.date
      const dataPartenza = longDateFormatter(new Date(datePartenzaObj[0] + 2000, datePartenzaObj[1], datePartenzaObj[2]))
      const dateDestinazioneObj = volo.destinazione.dataOra.date.date
      const dataDestinazione = longDateFormatter(new Date(dateDestinazioneObj[0] + 2000, dateDestinazioneObj[1], dateDestinazioneObj[2]))
      const vettoreSigla = volo.vettoreMarketing.objB
      const vettoreIcon = require('../../../../assets/images/airlines/' + vettoreSigla + '.gif')

      return {
        vettore: volo.vettoreMarketing.objA,
        vettoreIcon: vettoreIcon,
        numero: volo.numeroVolo,
        classe: volo.datiProposta.classe,
        aereo: volo.aeromobile.objA,
        bagaglio: volo.bagaglio.quantita + ' in stiva',
        // scali: this.scaliTecnici(),
        scali: volo.scali,
        partenza: {
          citta: volo.partenza.aeroporto.city.objA,
          aereoporto: airportName(volo.partenza.aeroporto.airport.objA),
          sigla: volo.partenza.aeroporto.airport.objB,
          terminal: volo.partenza.terminal,
          orario: orarioPartenza,
          data: dataPartenza
        },
        arrivo: {
          citta: volo.destinazione.aeroporto.city.objA,
          aereoporto: airportName(volo.destinazione.aeroporto.airport.objA),
          sigla: volo.destinazione.aeroporto.airport.objB,
          terminal: volo.partenza.terminal,
          orario: orarioDestinazione,
          data: dataDestinazione
        }
      }
    },
    scalo: function (scalo) {
      const orario = simpleTimeFormatter(scalo.dataOraArrivo.time.time[0], scalo.dataOraArrivo.time.time[1])
      return {
        orario: orario,
        aereoporto: airportName(scalo.aeroporto.label),
        sigla: scalo.aeroporto.value,
        terminal: scalo.terminalPartenza
      }
    },
    scaliTecnici: function () {
      return scaliTecniciFake
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/flight-panel/FlightSection.vue